import merge from 'lodash/merge';
import { Platform, StyleSheet } from 'react-native';
import { typographyConfig } from '../../constants';
import * as allColors from '../../constants/colors';
import { checkIsPlatform, fitContentWidth } from '../../utils';
export var getTypographyStyles = props => {
  var _a;
  var _ref = props || {},
    colorProp = _ref.color,
    type = _ref.type,
    hyperLinkProps = _ref.hyperLinkProps,
    multiText = _ref.multiText,
    textAlignment = _ref.textAlignment,
    isBold = _ref.isBold,
    config = _ref.config;
  var _type = isBold ? type.replace('-bold', '').concat('-bold') : type;
  var getTypoConfig = (_a = config === null || config === void 0 ? void 0 : config.types) === null || _a === void 0 ? void 0 : _a[_type];
  var fontWeight = (getTypoConfig === null || getTypoConfig === void 0 ? void 0 : getTypoConfig.isBold) ? config === null || config === void 0 ? void 0 : config.boldFontWeight : config === null || config === void 0 ? void 0 : config.regularFontWeight;
  var _fontFamily = (getTypoConfig === null || getTypoConfig === void 0 ? void 0 : getTypoConfig.isBold) ? config === null || config === void 0 ? void 0 : config.fontFamilyBold : config === null || config === void 0 ? void 0 : config.fontFamilyRegular;
  var display = checkIsPlatform('web') ? 'block' : 'flex';
  if (checkIsPlatform('web')) _fontFamily += ", sans-serif";
  var colorTokenValue = allColors[colorProp];
  return StyleSheet.create({
    typography: Object.assign(Object.assign(Object.assign(Object.assign({}, getTypoConfig === null || getTypoConfig === void 0 ? void 0 : getTypoConfig.typographyStyles), colorProp && {
      color: colorTokenValue || colorProp
    }), !checkIsPlatform('android') && {
      fontWeight
    }), {
      fontFamily: _fontFamily
    }),
    noTextTransform: {
      textTransform: 'none'
    },
    strikedText: {
      textDecorationLine: 'line-through'
    },
    hyperLink: Object.assign(Object.assign({}, fitContentWidth()), Platform.OS == 'web' && {
      display: 'inline'
    }),
    onHyperLinkHoverColor: {
      color: hyperLinkProps === null || hyperLinkProps === void 0 ? void 0 : hyperLinkProps.onHoverColor
    },
    singleTextAlignText: Object.assign(Object.assign({}, !(multiText === null || multiText === void 0 ? void 0 : multiText.length) && {
      display
    }), {
      textAlign: textAlignment
    }),
    multiTextAlignText: {
      display,
      textAlign: textAlignment
    }
  });
};
export var getTypographyProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(typographyConfig === null || typographyConfig === void 0 ? void 0 : typographyConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.typography) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};